import { DatePipe } from "@angular/common";
import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from "@angular/core";
import {
	FormGroup,
	FormArray,
	FormBuilder,
	Validators,
	FormControl,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { PreloaderService } from "@core";
import { DataService } from "@core/bootstrap/data.service";
import { AlertService } from "@shared/components/alert/alert.service";
import { LanguagePipe } from "@shared/pipes/language.pipe";
import * as moment from "moment";

declare var $: any;
@Component({
	selector: "overtime-step-one-configrations",
	templateUrl: "./step-one-configrations.component.html",
	styleUrls: ["./step-one-configrations.component.scss"],
})
export class OvertimeStepOneConfigrationsComponent implements OnInit {
	@Input() employee_data;
	@Input() form_request_id;
	@Input() form_key;
	@Input() allData;
	users: any = [];
	direct_anager: any = [];
	CreateSubmitted: boolean = false;
	min = new Date();
	form: FormGroup;
	submitted: boolean = false;
	lang_key = localStorage.getItem("lang_key") || "en";
	constructor(
		public ds: DataService,
		public datepipe: DatePipe,
		private snackBar: MatSnackBar,
		public lang: LanguagePipe,
		public spinner: PreloaderService,
		public alert: AlertService,
		public fb: FormBuilder,
		public router: Router,
		public changeDetectorRef: ChangeDetectorRef
	) {}
	emp_data: any = "";
	ngOnInit(): void {
		this.spinner.show();

		this.form = this.fb.group({
			financial_type: ["Over Time"],
			employee_number: [
				this.allData?.form_ovr1_data?.records[0]?.employee_number,
			],

			direct_manager: ["", [Validators.required]],
			createOverTimes: this.fb.group({
				overtime_date_english: ["", Validators.compose([Validators.required])],
				overtime_date_arabic: ["", Validators.compose([])],
				overtime_hours: ["", Validators.compose([Validators.required])],
				error_message: [""],
				overtime_amount: ["", Validators.compose([])],
			}),
			overTimes: this.fb.array([]),
		});

		this.form.patchValue({
			employee_number:
				this.allData?.form_ovr1_data?.records[0]?.employee_number,
			direct_manager: this.allData?.form_ovr1_data?.records[0]?.direct_manager,
		});
		this.users = [
			{
				label: this.allData?.form_ovr1_data?.records[0]?.direct_manager_name,
				value: this.allData?.form_ovr1_data?.records[0]?.direct_manager,
			},
		];

		this.fillFormWithData(this.allData);
		let data = new FormData();
		data.append(
			"employee_number",
			this.allData?.form_ovr1_data?.records[0]?.employee_number
		);

		this.spinner.show();
		this.ds.post(`human_resources/get_emp_details`, data).subscribe(
			(res) => {
				this.spinner.hide();
				if (res.status) {
					this.emp_data = res.records;
				} else {
					this.spinner.hide();
					this.showMsg(
						res.error || this.lang.transform("lang_employee_have_no_contract"),
						"ok",
						"error-snackbar"
					);
				}
			},
			(err) => {
				this.spinner.hide();
			}
		);
		this.spinner.hide();
	}
	monthes = [];

	monthesAfterSearch = [];
	checkFor50Percent() {
		const val = this.form.get("createOverTimes") as FormGroup;
		if (
			val.value.amount &&
			val.value.month_salary &&
			+val.value.amount > +val.value.month_salary / 2
		) {
			val.patchValue({
				...val.value,
				error_message: "lang_50_percent_error_message",
			});
		} else {
			val.patchValue({
				...val.value,
				error_message: "",
			});
		}
	}

	getControl(index: number) {
		return this.form.controls.overTimes["controls"][index] as FormGroup;
	}

	getItems(index: any) {
		let data = this.form.get("overTimes") as FormArray;

		return this.monthesAfterSearch.push({
			label: data.value[index].month,
			value: data.value[index].month,
		});
	}

	fillFormWithData(data) {
		const creds = this.form.get("overTimes") as FormArray;

		for (let index = 0; index < data?.form_ovr1_records?.length; index++) {
			const element = data?.form_ovr1_records[index];
			creds.push(
				this.fb.group({
					overtime_date_arabic: [
						element.overtime_date_arabic,
						Validators.compose([]),
					],
					overtime_date_english: [
						moment(element.overtime_date_english, "YYYY/MM/DD").format(),
						Validators.compose([Validators.required]),
					],
					overtime_hours: [element.overtime_hours, Validators.compose([])],
					errorMessage: [""],
					overtime_amount: [
						element.overtime_amount,
						Validators.compose([Validators.required]),
					],

					trackingId: this.generateUniqueId(),
				})
			);
		}
	}

	addInstallments() {
		this.CreateSubmitted = true;
		if (this.form?.controls?.createInstallments.status == "VALID") {
			if (!this.form?.value.loan_amount) {
				this.showMsg(
					"Please enter the loan you want first",
					"ok",
					"error-snackbar"
				);
				return 0;
			}

			const creds = this.form.get("installments") as FormArray;

			const val = this.form.get("createInstallments") as FormGroup;

			let totalValuesOfLoanPerMonthes = 0;
			for (let index = 0; index < creds.length; index++) {
				const element = creds["controls"][index].value;
				totalValuesOfLoanPerMonthes += Number(element.amount);
			}

			if (
				this.form?.value.loan_amount &&
				totalValuesOfLoanPerMonthes > this.form?.value.loan_amount
			) {
				this.showMsg(
					"Total amount values at all monthes must be equal to your loan value",
					"ok",
					"error-snackbar"
				);
				return 0;
			}

			if (
				val.value.amount &&
				val.value.month_salary &&
				+val.value.amount > +val.value.month_salary
			) {
				this.showMsg(
					"Your amout must not be bigger than your salary!",
					"ok",
					"error-snackbar"
				);
				return 0;
			}

			creds.push(
				this.fb.group({
					amount: [val.value.amount, Validators.compose([Validators.required])],
					due_month: [val.value.due_month, Validators.compose([])],
					due_year: [val.value.due_year, Validators.compose([])],
					errorMessage: [""],
					month: [val.value.month, Validators.compose([Validators.required])],
					month_salary: [val.value.month_salary, Validators.compose([])],
					trackingId: this.generateUniqueId(),
				})
			);

			this.monthesAfterSearch = this.monthesAfterSearch.filter((data) => {
				return data.value != val.value.month;
			});
			val.patchValue({
				month: this.monthesAfterSearch[0]
					? this.monthesAfterSearch[0].value
					: "",
			});
			val.reset();
			this.CreateSubmitted = false;
		} else {
			this.showMsg("Please fill all fields first", "ok", "error-snackbar");
		}
	}

	getThisMonthSalary() {
		this.CreateSubmitted = true;
		const creds = this.form.get("overTimes") as FormArray;

		const val = this.form.get("createOverTimes") as FormGroup;

		this.spinner.show();

		for (let index = 0; index < creds.value.length; index++) {
			const element = creds.value[index];
			if (
				moment(element.overtime_date_english).isSame(
					val.value.overtime_date_english
				)
			) {
				this.showMsg("lang_date_theSame_error", "ok", "error-snackbar");
				this.spinner.hide();
				return 0;
			}
		}

		let formData = new FormData();
		formData.append(
			"employee_number",
			this.allData?.form_ovr1_data?.records[0]?.employee_number
		);

		formData.append(
			"overtime_date",
			moment(this.form.value.createOverTimes.overtime_date_english).format()
		);
		formData.append(
			"overtime_hours",
			this.form.value.createOverTimes.overtime_hours
		);
		this.ds
			.post(`form/${this.form_key}/check_overtime_for_employee`, formData)
			.subscribe(
				(data) => {
					if (data?.status) {
						this.form.controls.createOverTimes.patchValue({
							...this.form?.controls?.createOverTimes.value,
							overtime_amount: data.data,
						});

						if (this.form?.controls?.createOverTimes.status == "VALID") {
							creds.push(
								this.fb.group({
									overtime_date_arabic: [
										val.value.overtime_date_arabic,
										Validators.compose([]),
									],
									overtime_date_english: [
										val.value.overtime_date_english,
										Validators.compose([Validators.required]),
									],
									overtime_hours: [
										val.value.overtime_hours,
										Validators.compose([]),
									],
									errorMessage: [""],
									overtime_amount: [
										val.value.overtime_amount,
										Validators.compose([Validators.required]),
									],

									trackingId: this.generateUniqueId(),
								})
							);

							val.reset();
							this.CreateSubmitted = false;
						} else {
							this.showMsg(
								"Please fill all fields first",
								"ok",
								"error-snackbar"
							);
						}
					} else {
						this.showMsg(data?.error, "ok", "error-snackbar");
					}

					this.spinner.hide();
				},
				(error) => {
					this.spinner.hide();
					this.alert.error(error);
				}
			);
	}

	showMsg(msg: string, action: string, className: string) {
		this.snackBar.open(msg, action, {
			duration: 4000,
			panelClass: [className],
		});
	}
	trackByFnCustom(index: number, item: any) {
		return item.trackingId;
	}
	generateUniqueId() {
		return (
			Math.random().toString(36).substring(2, 15) +
			Math.random().toString(36).substring(2, 15)
		);
	}

	mon;

	deleteCreds(index, cred) {
		const creds = this.form.get("overTimes") as FormArray;

		this.monthesAfterSearch = [
			...this.monthesAfterSearch,
			{
				label: cred.month,
				value: cred.month,
			},
		];

		creds.removeAt(index);
		this.changeDetectorRef.detectChanges();
	}

	public isNumber(evt) {
		evt = evt ? evt : window.event;
		var charCode = evt.which ? evt.which : evt.keyCode;
		if (charCode == 101 || charCode == 69) {
			return false;
		}
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}

	submitForm() {
		this.form.controls.createOverTimes.disable();
		if (this.form?.status == "VALID") {
			const creds = this.form.get("overTimes") as FormArray;

			this.spinner.show();
			let formData = new FormData();
			formData.append(
				"employee_number",
				this.allData?.form_ovr1_data?.records[0]?.employee_number
			);
			formData.append(
				"transaction_request_id",
				this.allData?.form_ovr1_data?.records[0]?.transaction_request_id
			);

			formData.append("direct_manager", this.form.value.direct_manager || "");
			this.form.value.overTimes.forEach((overTime, index) => {
				formData.append(
					`over_records[${index + 1}][overtime_date_english]`,
					moment(overTime.overtime_date_english).format("YYYY/MM/DD")
				);
				formData.append(
					`over_records[${index + 1}][overtime_date_arabic]`,
					overTime.overtime_date_arabic
				);
				formData.append(
					`over_records[${index + 1}][overtime_hours]`,
					overTime.overtime_hours
				);
				formData.append(
					`over_records[${index + 1}][overtime_amount]`,
					overTime.overtime_amount
				);
			});

			this.ds.post(`form/${this.form_key}/et`, formData).subscribe(
				(data) => {
					if (data.status) {
						this.showMsg(data.msg, "ok", "success-snackbar");

						//this.form.reset()
						setTimeout(() => {
							location.reload();
						}, 1000);
						this.spinner.hide();
					} else {
						this.spinner.hide();
						this.form.controls.createOverTimes.enable();
						this.showMsg(data.error, "ok", "error-snackbar");
					}
				},
				(error) => {
					this.spinner.hide();
					this.form.controls.createOverTimes.enable();
					this.alert.error(error);
				}
			);
		} else {
			this.form.controls.createInstallments.enable();
			this.showMsg("Please fill all fields first", "ok", "error-snackbar");
		}
	}

	public search_users(key) {
		if (key) {
			this.users = [];
			let param = new FormData();
			param.append("search", key.term);
			param.append("lang_key", this.lang_key);
			param.append("user_type_id", "1");
			this.ds
				.getActionByUrl(this.ds.formData2string(param), "tc/getformuserslist")
				.subscribe((res) => {
					this.spinner.hide();
					if (res.status) {
						this.users = res.list;
					}
				});
		}
	}
}
